import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import { Svg } from "../../../../../Svg";
import { NodeWithSvg } from "../../../NodeWithSvg";
import { useButton } from "../../button.hook";
import * as S from "./buttonBtn.style";
export var Btn = function(_param) {
    var children = _param.children, disabled = _param.disabled, _onClick = _param.onClick, _onMouseEnter = _param.onMouseEnter, _onMouseLeave = _param.onMouseLeave, _model = _param.model, model = _model === void 0 ? "regular" : _model, size = _param.size, svg = _param.svg, _svgPosition = _param.svgPosition, svgPosition = _svgPosition === void 0 ? "right" : _svgPosition, _type = _param.type, type = _type === void 0 ? "button" : _type, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, rest = _object_without_properties(_param, [
        "children",
        "disabled",
        "onClick",
        "onMouseEnter",
        "onMouseLeave",
        "model",
        "size",
        "svg",
        "svgPosition",
        "type",
        "variant"
    ]);
    var ref = useButton({
        _onClick: _onClick,
        _onMouseEnter: _onMouseEnter,
        _onMouseLeave: _onMouseLeave,
        disabled: disabled,
        size: size,
        variant: variant
    }), color = ref.color, height = ref.height, onClick = ref.onClick, onMouseEnter = ref.onMouseEnter, onMouseLeave = ref.onMouseLeave;
    return /*#__PURE__*/ _jsx(S.Button, _object_spread_props(_object_spread({}, rest), {
        disabled: disabled,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        model: model,
        size: size,
        type: type,
        variant: variant,
        children: model === "regular" ? /*#__PURE__*/ _jsx(NodeWithSvg, {
            color: color,
            height: height,
            svg: svg,
            svgPosition: svgPosition,
            children: children
        }) : /*#__PURE__*/ _jsx(Svg, {
            name: svg || "plusBtn",
            color: color,
            height: height
        })
    }));
};
